import { PdfExportService } from '../../../../services/export-pdf/pdf-export.service';
import { UserService } from '../../../../services/user.service';
var BestPerformingPostsComponent = /** @class */ (function () {
    function BestPerformingPostsComponent(pdfService, userService) {
        this.pdfService = pdfService;
        this.userService = userService;
        this.bestPerformingPosts = [];
        this.forPayingUser = false;
    }
    BestPerformingPostsComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.bestPerformingPosts.length === 0) {
            this.pdfService.incrementNumberReportReady(BestPerformingPostsComponent.COMPONENT_NAME);
        }
        this.pdfService.imagedLoadedTrigger.subscribe(function (data) {
            if (data.component === BestPerformingPostsComponent.COMPONENT_NAME
                && data.currentCounter === _this.bestPerformingPosts.length) {
                _this.pdfService.incrementNumberReportReady(BestPerformingPostsComponent.COMPONENT_NAME);
            }
        });
    };
    Object.defineProperty(BestPerformingPostsComponent.prototype, "hasNoData", {
        get: function () {
            return !Array.isArray(this.bestPerformingPosts)
                || this.bestPerformingPosts.length === 0
                || (this.forPayingUser && this.userService.isFreeUser() && !this.userService.isAdmin);
        },
        enumerable: true,
        configurable: true
    });
    BestPerformingPostsComponent.COMPONENT_NAME = 'BestPerformingPostsComponent';
    return BestPerformingPostsComponent;
}());
export { BestPerformingPostsComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/best-performing-posts/best-performing-posts.component.ts.pre-build-optimizer.js